// extracted by mini-css-extract-plugin
export default {"forceDesktop":"ViewPage_forceDesktop__jzg0C","desktop":"ViewPage_desktop__+vM6z","forceHF":"ViewPage_forceHF__O6oE4"};